<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[1]"
          pagination
          :data="qnaList || []"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.questionAnswerSet") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Question Set' })"
                size="small"
                >{{ $t("setup.label.addQuestionSet") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.CategoryName") }}</vs-th>
            <vs-th>{{ $t("setup.label.SubCategoryName") }}</vs-th>
            <vs-th>{{ $t("setup.label.TotalQuestions") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="user" v-for="(user, index) in data">
              <vs-td :data="user.categoryName">{{ user.categoryName }}</vs-td>
              <vs-td :data="user.subcategoryName">{{
                user.subcategoryName
              }}</vs-td>
              <vs-td :data="user.questionCount">{{
                user.questionCount
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <!-- <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="openView(user)"
                    class="icon_row"
                  /> -->
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(user)"
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      allAvailableUsers: (state) => state.teams.allAvailableUsers,
      qnaList: (state) => state.qna.qnaList,
      availibilityListByUserId: (state) => state.teams.availibilityListByUserId,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    async getQnAListMethod() {
      this.loading = true;
      try {
        await this.$store.dispatch("qna/getQnAListAction");
      } catch (e) {
        this.$toasted.error(e.message,{
          duration: 2000,
        });
      }
      this.loading = false;
    },
    editData(data) {
      this.$router.push({ name: "Edit Question Set", params: { category: data.categoryId, subCategory: data.subcategoryId } });
    },
    openView(e) {
      this.$router.push({
        name: "View User Availability",
        params: { id: e.id },
      });
    },
  },

  async mounted() {
    await this.getQnAListMethod();
  },
};
</script>

<style lang="scss">
.availability-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.availability-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
</style>
